/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

// required attributes
const StationCreditorInstitutionR = t.interface({
  business_name: t.string,

  creditor_institution_code: t.string,

  enabled: withDefault(t.boolean, true)
});

// optional attributes
const StationCreditorInstitutionO = t.partial({
  aca: t.boolean,

  application_code: t.Integer,

  aux_digit: t.Integer,

  broadcast: t.boolean,

  description: t.string,

  mod4: t.boolean,

  segregation_code: t.Integer,

  spontaneous_payment: t.boolean,

  stand_in: t.boolean
});

export const StationCreditorInstitution = t.intersection(
  [StationCreditorInstitutionR, StationCreditorInstitutionO],
  "StationCreditorInstitution"
);

export type StationCreditorInstitution = t.TypeOf<
  typeof StationCreditorInstitution
>;
